module.exports = __webpack_public_path__ + "img/cloth_g1_item_06.876caac1.svg";